import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { apiListBranch } from "../../../api/master";
import Select from "react-select";

function CompanyViews(props) {
  const [branch, setBranchValue] = useState([]);
  const [user, setUser] = useState({});

  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  async function getBranch() {
    await apiListBranch({ paginate: 0 }).then((result) =>
      setBranchValue(result.data.data.list),
    );
  }

  useEffect(() => {
    getBranch();
  }, []);

  const branchOptions = branch.map((list) => ({
    value: list.branch_id,
    label: list.branch_name,
  }));

  const selectedBranches = branchOptions.filter((option) =>
    props.id?.branch_id?.includes(option.value),
  );

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "12rem", height: "4px" }} id="modalhead">
          View Godown
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <div className="row gy-3">
          <div className="col-md-6">
            <label htmlFor="godown_name">Godown Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="godown_name"
              value={props.id?.godown_name || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="tally_godown_name">Tally Godown Name</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="tally_godown_name"
              value={props.id?.tally_godown_name || ""}
            />
          </div>
          <div className="col-md-6">
            <label htmlFor="godown_address">Godown Address</label>
            <input
              disabled
              type="text"
              className="form-control"
              id="godown_address"
              value={props.id?.godown_address || ""}
            />
          </div>
          {user.role_id === 2 && (
            <div className="col-md-6">
              <label htmlFor="branch_name">Branch</label>
              <Select
                isMulti
                isDisabled
                options={branchOptions}
                value={selectedBranches}
                className="form-control p-0"
                classNamePrefix="select"
              />
            </div>
          )}
          <div className="col-12 mt-4">
            <button
              className="branchModalCancel"
              onClick={props.hide}
              style={{
                height: "33px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                float: "right",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyViews;
